import React from 'react';

import SvgContainer from '../SvgContainer';

const CircleClose = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9078_100929)">
                <path d="M8 0C3.576 0 0 3.576 0 8C0 12.424 3.576 16 8 16C12.424 16 16 12.424 16 8C16 3.576 12.424 0 8 0ZM11.436 10.308C11.7475 10.6195 11.7475 11.1245 11.436 11.436C11.1245 11.7475 10.6195 11.7475 10.308 11.436L8 9.128L5.692 11.436C5.38051 11.7475 4.87549 11.7475 4.564 11.436C4.25251 11.1245 4.25251 10.6195 4.564 10.308L6.872 8L4.564 5.692C4.25251 5.38051 4.25251 4.87549 4.564 4.564C4.87549 4.25251 5.38051 4.25251 5.692 4.564L8 6.872L10.308 4.564C10.6195 4.25251 11.1245 4.25251 11.436 4.564C11.7475 4.87549 11.7475 5.38051 11.436 5.692L9.128 8L11.436 10.308Z" />
            </g>
            <defs>
                <clipPath id="clip0_9078_100929">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default CircleClose;
